import classNames from 'classnames';
import { IconEye, IconEyeOff } from 'featherico';
import Button from '../../../../../components/Button';
import styles from './style.m.less';

export const ConfidentialQuestionToggle = ({ toggleConfidentialQuestions, showConfidentialQuestions }) => {
    return (
        <Button
            onClick={toggleConfidentialQuestions}
            className={classNames(styles.pageHeaderButton, { done: showConfidentialQuestions })}
        >
            {showConfidentialQuestions ? (
                <>
                    <IconEyeOff /> Hide
                </>
            ) : (
                <>
                    <IconEye /> Include
                </>
            )}{' '}
            Confidential Questions
        </Button>
    );
};
